export default {
  content: {
    id: 'product_jp_product_condition_body_carousel_grade_b_content',
    defaultMessage:
      'There are minor scratches that are only visible from a distance of 50cm.',
  },
  pill1: {
    id: 'product_jp_product_condition_body_carousel_grade_b_pill_1',
    defaultMessage: 'Verified parts',
  },
  pill2: {
    id: 'product_jp_product_condition_body_carousel_grade_b_pill_2',
    defaultMessage: '80~100% battery capacity guarantee',
  },
  grade: {
    id: 'product_jp_grade_11',
    defaultMessage: 'B grade (Good)',
  },
}
